import React, { PropsWithChildren, ReactElement, ReactNode } from "react";
import { Headline } from "./Headline";

interface ChildProps extends PropsWithChildren {
  title: string;
}

function Section({ children }: { children: ReactNode }): JSX.Element {
  if (!React.isValidElement<ChildProps>(children)) return <>{children}</>;

  return (
    <>
      {children.props.title && (
        <Headline level={3} className="ml-4 ">
          {children.props.title}
        </Headline>
      )}
      <div className="lg:bg-bg-gray lg:p-4 lg:rounded-lg h-full">
        {children}
      </div>
    </>
  );
}

export const ResponsiveContainer = ({
  widthLeft = 50,
  rightAuto = false,
  children,
  order,
}: {
  widthLeft?: number;
  rightAuto?: boolean;
  order?: string[];
  children?:
    | ReactElement<ChildProps>
    | [ReactElement<ChildProps>, ReactElement<ChildProps> | undefined];
}) => {
  if (!Array.isArray(children) && !widthLeft) {
    widthLeft = 50;
  }
  const centerGap = widthLeft === 50 ? "lg:flex-1" : "";
  return (
    <div className={`flex flex-col lg:flex-row gap-4 max-h-full`}>
      {React.Children?.map(children, (child, i) => {
        if (!React.isValidElement<ChildProps>(child)) return;

        const sections = child.props.title
          ? [child]
          : React.Children.toArray(child.props.children);

        return i === 0 ? (
          <div
            className={`lg:w-[${widthLeft}%] flex flex-col h-full ${centerGap} ${
              order && order.length > 0 ? order[i] : ""
            }`}
          >
            {sections.map((section, sectionIndex) => (
              <Section key={sectionIndex}>{section}</Section>
            ))}
          </div>
        ) : (
          <div
            className={`
            lg:flex-1 
            lg:w-[${rightAuto ? "auto" : 100 - widthLeft + "%"}]
            
            flex flex-col
            `}
          >
            {sections.map((section, sectionIndex) => (
              <Section key={sectionIndex}>{section}</Section>
            ))}
          </div>
        );
      })}
    </div>
  );
};
